import { render, staticRenderFns } from "./CstmrRegByCstmr.vue?vue&type=template&id=cef517fc&"
import script from "./CstmrRegByCstmr.vue?vue&type=script&lang=js&"
export * from "./CstmrRegByCstmr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports